var _path, _rect, _path2, _path3, _path4, _rect2, _rect3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _mask, _g, _rect4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 180C139.706 180 180 139.706 180 90C180 40.2944 139.706 0 90 0C40.2944 0 0 40.2944 0 90C0 139.706 40.2944 180 90 180Z",
    fill: "#0B0251"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.3916,
    y: 99.5474,
    width: 48.5091,
    height: 0.516054,
    rx: 0.258027,
    fill: "#D8D8D8",
    stroke: "#979797",
    strokeWidth: 0.55625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4922 55.6828H136.735C137.59 55.6828 138.283 56.3759 138.283 57.2309V132.575C138.283 133.43 137.59 134.123 136.735 134.123H45.9096C38.4994 134.123 32.4922 128.116 32.4922 120.706V55.6828Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6368 140.881C93.663 141.857 94.354 143.523 95.7326 143.523H147.452C148.307 143.523 149 142.83 149 141.975V90.1568C149 88.7768 147.331 88.0864 146.356 89.0631L94.6368 140.881Z",
    fill: "#F2C94C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144 106.5C144 106.224 144.224 106 144.5 106H149V107H144.5C144.224 107 144 106.776 144 106.5Z",
    fill: "#0B0251"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 138,
    width: 33,
    height: 2,
    rx: 1,
    fill: "#0B0251"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 109.184,
    y: 131.051,
    width: 37.582,
    height: 2,
    rx: 1,
    transform: "rotate(-44 109.184 131.051)",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144 115.5C144 115.224 144.224 115 144.5 115H149V116H144.5C144.224 116 144 115.776 144 115.5Z",
    fill: "#0B0251"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.643 129.483C118.668 130.459 119.358 132.126 120.738 132.126H135.578C136.433 132.126 137.126 131.433 137.126 130.578V115.738C137.126 114.358 135.459 113.668 134.483 114.643L119.643 129.483Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144 123.5C144 123.224 144.224 123 144.5 123H149V124H144.5C144.224 124 144 123.776 144 123.5Z",
    fill: "#0B0251"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144 132.5C144 132.224 144.224 132 144.5 132H149V133H144.5C144.224 133 144 132.776 144 132.5Z",
    fill: "#0B0251"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.492071,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.55 52.3009C32.5181 46.4828 37.2257 41.7493 43.0439 41.7493C48.6167 41.7493 53.1344 46.2669 53.1344 51.8397V111.873C53.1344 115.863 49.8997 119.098 45.9096 119.098C45.9096 119.098 40.4754 119.244 38.1743 120.157C36.1536 120.96 32.9443 124.246 32.9443 124.246L32.55 52.3009Z",
    fill: "black",
    fillOpacity: 0.118499
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9096 37.1048V107.288C45.9096 108.428 44.9854 109.352 43.8454 109.352C34.677 109.352 32.5105 116.969 32.5105 121.268L32.4922 50.5222C32.4922 43.1861 38.3798 37.2251 45.6877 37.1066L45.9096 37.1048Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6335 82.218L121.732 35.1197C123.344 33.5074 125.958 33.5074 127.57 35.1197L133.044 40.5933C134.656 42.2055 134.656 44.8195 133.044 46.4318L85.7961 93.6794L69.3894 98.7741L74.6335 82.218Z",
    fill: "#73C3F9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 33,
    width: 66,
    height: 66
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6335 82.218L121.732 35.1197C123.344 33.5074 125.958 33.5074 127.57 35.1197L133.044 40.5933C134.656 42.2055 134.656 44.8195 133.044 46.4318L85.7961 93.6794L69.3894 98.7741L74.6335 82.218Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.3086,
    y: 88.5426,
    width: 8.9,
    height: 15.9977,
    transform: "rotate(-45 68.3086 88.5426)",
    fill: "#3C21F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.958,
    y: 43.6547,
    width: 6.675,
    height: 17.8,
    transform: "rotate(-45 111.958 43.6547)",
    fill: "#3C21F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.623,
    y: 40.2284,
    width: 1.03211,
    height: 15.9977,
    transform: "rotate(-45 116.623 40.2284)",
    fill: "#0B0251"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.152 89.9031L78.3078 96.0589L69.3719 98.7999L72.152 89.9031Z",
    fill: "#0B0251"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3916,
    y: 99.5474,
    width: 59.8623,
    height: 2.58027,
    rx: 1.29014,
    fill: "#0B0251"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentTemplateIcon);
export default __webpack_public_path__ + "static/media/document-template-icon.80649001107e7fef23fd849af41d8b40.svg";
export { ForwardRef as ReactComponent };